const apply = {
  name: 'apply',
  path: 'apply',
  component: resolve => require(['../../components/pages/apply'], resolve),
  redirect: 'apply/enroll/sign',
  children: [{
    path: 'enroll/sign',
    component: resolve => require(['../../components/pages/apply/enroll/sign'], resolve)
  },
  {
    path: 'enroll/sign/result',
    component: resolve => require(['../../components/pages/apply/enroll/sign/signResult'], resolve)
  }, {
    path: 'enroll/signEditor',
    component: resolve => require(['../../components/pages/apply/enroll/signEditor'], resolve)
  },
  {
    path: 'enroll/signEditor/result',
    component: resolve => require(['../../components/pages/apply/enroll/signEditor/signResult'], resolve)
  }]
}

export default apply



// WEBPACK FOOTER //
// ./src/router/pages/apply.js